import React from 'react';

import InterestCell from '../Table/Decorator/Filter/InterestCell';

import { ExtraInterestTypes } from '../../../Enum/Interest/ExtraInterestProperties';
import { Interest } from '../../../Interface/Response/Interest/Interest';

import { capitalizeFirstLetter } from '../../../Helpers/String';

interface Props {
    type: ExtraInterestTypes,
    interest: Interest,
}

const ExtraInterestMessage: React.FC<Props> = ({ type, interest }) => (
    <div className="interest-message">
        <div className="d-flex mb-3">
            <div className="pl-0 col-1">{capitalizeFirstLetter(type)}</div>
            <div className="col-1">
                <InterestCell interest={interest} />
            </div>
        </div>
    </div>
);

export default ExtraInterestMessage;
